export default "/images/whiteborderlogo.png?8b3b478dbb69f8284c6dee7a0296025e";